import './index.scss';
import * as config from 'config.js';
import { ReactQueryDevtools } from 'react-query/devtools';

const ReactQueryDevTool = () => (config.isLocal() ? (<ReactQueryDevtools />) : null);

export const Footer = () => (
  <footer className="rax-footer mt-auto">
    <div className="rax-footer__content container-fluid">
      <nav className="rax-footer__links">
        <a
          href="https://www.rackspace.com/information/legal/privacystatement"
          target="_blank"
          title="Privacy Statement"
          rel="noopener noreferrer"
        >
          Privacy
        </a>
        <a
          href="https://www.rackspace.com/information/legal/websiteterms"
          target="_blank"
          title="Term of Use"
          rel="noopener noreferrer"
        >
          Terms
        </a>
      </nav>
      <small className="rax-footer__copyright">
        &copy;
        {new Date().getFullYear()}
        {' '}
        Rackspace Technology, US
      </small>
    </div>
    <ReactQueryDevTool />
  </footer>
);

export default Footer;
